import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ElementRef} from '@angular/core';
import {Filters} from '../../../shared/interfaces/wheels';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from '../../../shared/services/data.service';
import { MyProfile } from 'src/app/shared/interfaces/MyAccount.interface';
import { ApiServices } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Component({
  selector: 'app-wheel-filters',
  templateUrl: './wheel-filters.component.html',
  styleUrls: ['./wheel-filters.component.scss']
})
export class WheelFiltersComponent implements OnInit {
  @ViewChild('hideOutOfStock', { static: false }) hideOutOfStockCheckbox!: ElementRef;
  @ViewChild('showOutOfStock', { static: false }) showOutOfStockCheckbox!: ElementRef;
  @Input() filters: Filters;
  @Output() filterSelected = new EventEmitter();
  @Output() onClear = new EventEmitter();
  @Output() onhideFilters = new EventEmitter();
  @Input() diameter: any;
  @Input() showFilters = false;
  @Input() searchVehiclehome = 0;
  
  profileData: MyProfile;
  offsetMin:number = null;
  offsetMax:number = null;
  is_show_hub_bore:boolean = false;
  hub_bore_filtered:boolean = false;
  show_center_bore:boolean = false;
  show_wheel_weight:boolean = false;
  hub_bore:any = null;
  queryParams: any;
  offsetFilter:any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private apiService: ApiServices,
    private helperService: HelperService
  ) {
    activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.queryParams = params;
      }
      if (params.hasOwnProperty("hub_bore")) {
        this.hub_bore_filtered = true;
        this.hub_bore = localStorage.getItem("hub_bore");
      } else {
        this.hub_bore_filtered = false;
      }
      if (params.hasOwnProperty("make")) {
        this.hub_bore = localStorage.getItem("hub_bore");
        this.is_show_hub_bore = true;
      } else {
        this.is_show_hub_bore = false;
        localStorage.removeItem("hub_bore");
      }
      // this.setOptions();
      this.helperService.getMyAccountData();
      this.dataService.myAccountData.asObservable().subscribe(
        myAccountData => {
          if(myAccountData) {
            this.profileData = myAccountData.my_profile;
          }
        }
      );
    });
  }


  ngOnInit(): void {
    this.offsetFilter = [];
    localStorage.removeItem("show_center_bore");
    localStorage.removeItem("show_wheel_weight");
    this.offsetFilter = [
      {'name': "-180mm to -170mm"},
      {'name': "-170mm to -160mm"},
      {'name': "-160mm to -150mm"},
      {'name': "-150mm to -140mm"},
      {'name': "-140mm to -130mm"},
      {'name': "-130mm to -120mm"},
      {'name': "-120mm to -110mm"},
      {'name': "-110mm to -100mm"},
      {'name': "-100mm to -90mm"},
      {'name': "-90mm to -80mm"},
      {'name': "-80mm to -70mm"},
      {'name': "-70mm to -60mm"},
      {'name': "-60mm to -50mm"},
      {'name': "-50mm to -40mm"},
      {'name': "-40mm to -30mm"},
      {'name': "-30mm to -20mm"},
      {'name': "-20mm to -10mm"},
      {'name': "-10mm to 0mm"},
      {'name': "0mm to 10mm"},
      {'name': "10mm to 20mm"},
      {'name': "20mm to 30mm"},
      {'name': "30mm to 40mm"},
      {'name': "40mm to 50mm"},
      {'name': "50mm to 60mm"},
      {'name': "60mm to 70mm"}
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.filters) {
      this.setOptions();
    }
  }

  setOptions = () => {
    Object.keys(this.queryParams).forEach(param => {
      const values = this.queryParams[param].split(',');
      ////////////////////////////
      // Only for Static Offsets
      ////////////Starts

      if(this.queryParams.hide_out_of_stock && this.queryParams.hide_out_of_stock == 1) {
        if (this.hideOutOfStockCheckbox) {
          this.hideOutOfStockCheckbox.nativeElement.checked = true;
        }
      }
      if(this.queryParams.show_out_of_stock && this.queryParams.show_out_of_stock == 1) {
        if(this.showOutOfStockCheckbox) {
          this.showOutOfStockCheckbox.nativeElement.checked = true;
        }
      }

      if(param == 'offset'){
       const offset_array = values[0].split("to");
       if(offset_array.length == 2) {
        const minOffset = isNaN(parseInt(offset_array[0])) ? -1 : parseInt(offset_array[0]);
        const maxOffset = isNaN(parseInt(offset_array[1])) ? -1 : parseInt(offset_array[1]);
        const offsetMinElement = document.querySelector("#minOffset") as HTMLInputElement;
        const offsetMaxElement = document.querySelector("#maxOffset") as HTMLInputElement;
        offsetMinElement.value = minOffset.toString();
        offsetMaxElement.value = maxOffset.toString();
       }
        // // for radio buttons
        // this.offsetFilter.forEach(item => {
        //   let name = item.name;
        //   name = name.replace(/\s/g, '').replace(/mm/g, '');
        //   if (values.includes(name)) {
        //     item.checked = true;
        //   }
        // });


        // // for inputs
        // let MinAndMax = values[0].split('to');
        // if(MinAndMax.length == 2){
        //   this.offsetMin = MinAndMax[0];
        //   this.offsetMax = MinAndMax[1];
        // } else {
        //   this.offsetMin = MinAndMax[0];
        //   this.offsetMax = null;
        // }


      } else {
      ////////////////////////////
      // Only for Static Offsets
      //////////// Ends

        if (this.filters[param]) {
          this.filters[param].forEach(item => {
            if (values.includes(item.name)) {
              item.checked = true;
            }
          });
        }


      }
    });
  }

  updateQty(event, type:number){
    let value_element = event.target.closest(".quantity_update_filter").querySelector(".form-control");
    let new_qty = 0;

    if ( type == 0 ) {
      new_qty = parseInt(value_element.value) > 1 ? parseInt(value_element.value) - 1 : 1
    } else {
      new_qty = parseInt(value_element.value) + 1
    }
    value_element.value = new_qty
  }

  onFilter = (event, filter, qty_filter_active = false, static_target = false) => {
    const selectedFilter = {};
    const valueArr = event.target.value.split('|');
    if(filter != null){ // Only for Static Offsets


      if ( event.target.checked) {
        if (valueArr[0] == 'rim_diameter') {
          this.filters.rim_diameter.forEach(item => {
            item.checked = false;
          });
        } else if(valueArr[0] == 'offset'){
          this.offsetFilter.forEach((item, index) => {
            item.checked = false;
          });
        }
          filter.checked = true;
      } else {
          filter.checked = false;
      }
    }// Only for Static Offsets
    else if(filter === null){
      this.offsetFilter.forEach((item, index) => {
        item.checked = false;
      });
    }
    
    if(this.filters) {
      Object.keys(this.filters).forEach(key => {
        const filterKey = {
          key, values: []
        };
        const values = [];
        this.filters[key].forEach((item, index) => {
          if (item.checked) {
            filterKey.values.push(item.name);
            values.push(item.name);
          }
          
          if (index == this.filters[key].length - 1 && values.length) {
            selectedFilter[key] = values.join(',');
          }
        });
      });
    }
    
    let already_quantity_filtered = new URLSearchParams(window.location.search).get('min_quantity');
    let already_hideoutofstock_active = new URLSearchParams(window.location.search).get('hide_out_of_stock');
    let already_showoutofstock_active = new URLSearchParams(window.location.search).get('show_out_of_stock');
    let already_excludesupplier_active = new URLSearchParams(window.location.search).get('exclude_supplier_products');
    if ( qty_filter_active  && valueArr[0] == 'min_quantity') {
      let value_element = event.target.closest(".card-body").querySelector(".form-control");
      selectedFilter['min_quantity'] = value_element.value;
    } else if ( already_quantity_filtered != null ) {
      selectedFilter['min_quantity'] = already_quantity_filtered;
    }

    let already_offset_filtered = new URLSearchParams(window.location.search).get('offset');
    if ( qty_filter_active  && valueArr[0] == 'offset') {
      const offsetParent = event.target.closest(".card-body");
      const minOffset = parseInt(offsetParent.querySelector("#minOffset").value);
      const maxOffset = parseInt(offsetParent.querySelector("#maxOffset").value);
      if (isNaN(minOffset) || isNaN(maxOffset)) {
        alert("Please Enter Correct Offset Filter");
        return;
      } else {
        selectedFilter["offset"] = `${minOffset}to${maxOffset}`;
      }
    } else if (already_offset_filtered) {
      const offsets = already_offset_filtered.split("to");
      selectedFilter["offset"] = `${offsets[0]}to${offsets[1]}`;
    }

    
    let activeElement = event.target as HTMLInputElement;
    if (static_target) {
      // const profle_data = {
      //   is_hide_out_of_stock: event.target.checked,
      // }
      // this.apiService.updatePofileSettings(profle_data).subscribe(
      //   response => {
      //   },
      //   error => {}
      // );

      if (event.target.checked && valueArr[0] != 'hub_bore' && valueArr[0] != 'exclude_supplier_products') {
        selectedFilter[valueArr[0]] = 0;
        selectedFilter[valueArr[0]] = 1
        // const hide_stock_label = activeElement.closest(".hide_stock_label") as HTMLElement;
        // if (hide_stock_label) {
        //   const span = hide_stock_label.querySelector("span");
        //   if (span) {
        //     span.textContent = "Show Out of Stock"
        //   }
        // }
       
      } else if (already_hideoutofstock_active != null && valueArr[0] != "hide_out_of_stock") {
        selectedFilter['hide_out_of_stock'] = 1
        // const hide_stock_label = activeElement.closest(".hide_stock_label") as HTMLElement;
        // if (hide_stock_label) {
        //   const span = hide_stock_label.querySelector("span");
        //   if(span) {
        //     span.textContent = "Show Out of Stock"
        //   }
        // }
      } else if (!event.target.checked && valueArr[0] != 'hub_bore' && valueArr[0] != 'exclude_supplier_products') {
        selectedFilter[valueArr[0]] = 0;
      }
    }

    if (valueArr[0] === 'hub_bore' && event.target.checked) {
      selectedFilter['hub_bore'] = valueArr[1];
    }

    if (already_showoutofstock_active != null && valueArr[0] != "show_out_of_stock") {
      selectedFilter['show_out_of_stock'] = parseInt(already_showoutofstock_active)
    }
    if (already_excludesupplier_active != null && valueArr[0] != 'exclude_supplier_products') {
      selectedFilter['exclude_supplier_products'] = parseInt(already_excludesupplier_active);
    }

    if(valueArr[0] == 'exclude_supplier_products') {
      selectedFilter['exclude_supplier_products'] = event.target.checked ? 1 : 0
    }

    ////////////////////////////
    // Only for Static Offsets
    ////////////Starts
    // selectedFilter['offset'] = null;

    // if(this.offsetMin < -180 && this.offsetMin != null) { this.offsetMin = -180; } else if(this.offsetMin > 70 && this.offsetMin != null) { this.offsetMin = 70; }
    // if(this.offsetMax < -180 && this.offsetMax != null) { this.offsetMax = -180; } else if(this.offsetMax > 70 && this.offsetMax != null) { this.offsetMax = 70; }

    // if(this.offsetMin >= -180 && this.offsetMin <= 70 && this.offsetMin != null){
    //   selectedFilter['offset'] = this.offsetMin;
    // }
    // if(this.offsetMax >= -180 && this.offsetMax <= 70 && this.offsetMax != null){
    //   selectedFilter['offset'] = this.offsetMax;
    // }

    // if(this.offsetMin >= -180 && this.offsetMin <= 70 && this.offsetMax >= -180 && this.offsetMax <= 70 && this.offsetMin != null && this.offsetMax != null){
    //   selectedFilter['offset'] = this.offsetMin+'to'+this.offsetMax;
    // }


    // if(valueArr[0] == 'offset'){
    //   let offVal = [];

    //   this.offsetFilter.forEach((item, index) => {
    //     if (item.checked) {
    //       let name = item.name;
    //       name = name.replace(/\s/g, '');
    //       name = name.replace(/mm/g, '');
    //       offVal.push(name);

    //       let minAndMaxOffset = name.split('to');
    //       this.offsetMin = minAndMaxOffset[0];
    //       this.offsetMax = minAndMaxOffset[1];

    //     }

    //     if (offVal.length) {
    //       selectedFilter['offset'] = offVal.join(',');
    //     }
    //   });
    // }

    if (valueArr[0] == 'center_bore') {
      selectedFilter['center_bore'] = valueArr[1];
    }
    
    if (valueArr[0] == 'load_rating') {
      selectedFilter['load_rating'] = valueArr[1];
    }

    ////////////////////////////
    // Only for Static Offsets
    ////////////Ends

    const queryParams = {
      // year: this.queryParams.year,
      pagination: 1,
    };
    if (this.queryParams.hasOwnProperty('center_bore')) {
      queryParams["center_bore"] = this.queryParams.center_bore;
    }

    if (this.queryParams.hasOwnProperty('load_rating')) {
      queryParams["load_rating"] = this.queryParams.load_rating;
    }


    const params = {...queryParams, ...selectedFilter};
    if(this.searchVehiclehome){
      // console.log(this.queryParams);
      const queryParams2 = {
        front_rim_diameter: this.queryParams.front_rim_diameter,
        front_rim_width: this.queryParams.front_rim_width,
        front_bolt_pattern: this.queryParams.front_bolt_pattern,
        rear_rim_diameter: this.queryParams.rear_rim_diameter,
        rear_rim_width: this.queryParams.rear_rim_width,
        search_by_size: this.queryParams.search_by_size,
      };

      const params2 = {...queryParams2, ...selectedFilter};
      this.filterSelected.emit(params2);

    } else {
      if(valueArr[0] == 'hub_bore' && !event.target.checked) {
        const { hub_bore, ...newQueryParams } = this.queryParams;
        this.queryParams = newQueryParams;

        this.router.navigate(['wheels'], { queryParams: {...this.queryParams}});
      }else {

        // handling the case when we will hve empty center bore and load rating
        if (params.hasOwnProperty("center_bore") && params["center_bore"] == '') {
          delete params["center_bore"];
        }

        if (params.hasOwnProperty("load_rating") && params["load_rating"] == '') {
          delete params["load_rating"];
        }
        this.filterSelected.emit(params);
        // debugger;
        // this.router.navigate(['wheels'], {...this.queryParams, ...selectedFilter});
      }
    }

    // this.filterSelected.emit(params);
  }

  deleteKeyFromURL(key:string) {
    let url = window.location.href;
    let parsedUrl = new URL(url);
    let searchParams = parsedUrl.searchParams;
    searchParams.delete(key);
    parsedUrl.search = searchParams.toString();
    window.history.replaceState(null, '', parsedUrl.toString());
  }

  toggleHideShowFilter(event:any, filterName){
    if (event.target.checked) {
      if (filterName == 'hub_bore'){
        this.show_center_bore = true;
        localStorage.setItem("show_center_bore", 'true');
      } else if (filterName == "wheel_weight") {
        this.show_wheel_weight = true;
        localStorage.setItem("show_wheel_weight", 'true');
      }
    } else {
      if (filterName == 'hub_bore'){
        this.show_center_bore = false;
        localStorage.removeItem("show_center_bore");
      } else if (filterName == "wheel_weight") {
        this.show_wheel_weight = false;
        localStorage.removeItem("show_wheel_weight");
      }
    }

    let targetElms = document.querySelectorAll(`.${filterName}`);
    if ( event.target.checked ) {
      targetElms.forEach((te)=>{
        te.classList.remove("d-none");
      })
    } else {
      targetElms.forEach((te)=>{
        te.classList.add("d-none");
      })
    }
  }

  clearAll() {
    Object.keys(this.filters).forEach(key => {
      this.filters[key].forEach(item => item.checked = false);
    });

    this.offsetFilter.forEach((item, index) => {
      this.filters['offset'].forEach(item => item.checked = false);
    });

    // hide all static checkboxes 
    this.hideStaticCheckboxes();
    // reset load rating and cenetr bore selectboxes to default 
    this.resetSelectBoxes();

    // setting minimum quantity to 0 
    const minimum_quantity_inputs = document.querySelectorAll(".minimum-qty-input");
    minimum_quantity_inputs.forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.value = "1";
      }
    });

    this.offsetMin = null;
    this.offsetMax = null;

    const params = {
      // year: this.queryParams.year,
      // make: this.queryParams.make,
      // model: this.queryParams.model,
      pagination: 1
    };

    this.dataService.vehicleFormData.asObservable().subscribe(data => {
      if (data) {
        const queryParams = {...params, ...data};
        this.filterSelected.emit(queryParams);
      } else {
        if(this.searchVehiclehome){
          // console.log(this.queryParams);
          const queryParams2 = {
            front_rim_diameter: this.queryParams.front_rim_diameter,
            front_rim_width: this.queryParams.front_rim_width,
            front_bolt_pattern: this.queryParams.front_bolt_pattern,
            rear_rim_diameter: this.queryParams.rear_rim_diameter,
            rear_rim_width: this.queryParams.rear_rim_width,
            search_by_size: this.queryParams.search_by_size,
          };
          this.filterSelected.emit(queryParams2);
        } else {
          this.filterSelected.emit(params);
        }
      }
    });
   // this.onClear.emit(true);
  }

  private resetSelectBoxes(){
    document.querySelectorAll(".new-select-box").forEach((selelem) => {
      if (selelem instanceof HTMLSelectElement) {
        selelem.selectedIndex = 0;
      }
    });
  }

  private hideStaticCheckboxes(){
    const checkboxContainers = document.querySelectorAll(".new-checkbox");
    checkboxContainers.forEach((ckcontainer)=> {
      let container = ckcontainer as HTMLElement;
      container.querySelectorAll("input").forEach((chkbox=>{
        chkbox.checked = false;
      }))
    })
  }

  hideFilters(): void {
    this.onhideFilters.emit();
  }
}
